// @ts-nocheck

import { OverlayStateActionTypes } from '../types/actions/overlay';

export const playOverlayAnimation = (animationId) => ({
  type: OverlayStateActionTypes.PLAY_ANIMATION,
  payload: { animationId },
});

export const stopOverlayAnimation = () => ({
  type: OverlayStateActionTypes.STOP_ANIMATION,
});

export default {
  playOverlayAnimation,
  stopOverlayAnimation,
};
